module.exports = __webpack_public_path__ + "img/background_principal_mov-1070.9e0648cf.webp";